"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
var Icon_1 = require("../Icon");
var Tab_1 = require("../Tab");
var SubTab_1 = require("./SubTab");
require("./Tab.scss");
var Tab = (function (_super) {
    __extends(Tab, _super);
    function Tab(props) {
        var _this = _super.call(this, props) || this;
        _this.createPanelsArray = function (children) {
            var panels = children.type === Tab_1.TabPanel ?
                [{ key: children.props.index, panel: React.createElement("div", { className: (_this.props.vertical ? 'vertical_tab_panel' : 'tab_panel') + children.className }, children.props.children) }] :
                children.flatMap(function (child) {
                    if (child.type === SubTab_1.SubTab) {
                        return _this.createPanelsArray(child.props.children);
                    }
                    else {
                        return { key: child.props.index, panel: React.createElement("div", { className: (_this.props.vertical ? 'vertical_tab_panel' : 'tab_panel') + child.className }, child.props.children) };
                    }
                });
            return panels;
        };
        _this.handleClick = function (index, event) {
            event.preventDefault();
            if (_this.props.onPanelChange) {
                _this.props.onPanelChange(index);
            }
            _this.setState({
                selected: index
            });
        };
        _this.labels = function (child, depth) {
            var activeClass = (_this.state.selected === child.props.index ? 'active' : '');
            var icon = _this.props.vertical ? React.createElement(Icon_1.Icon, { icon: 'right', size: 'medium' }) : '';
            return (React.createElement("li", { key: child.props.index, style: { paddingLeft: (12 * depth) } },
                React.createElement("a", { href: '#', className: activeClass, onClick: _this.handleClick.bind(_this, child.props.index) },
                    child.props.label,
                    icon)));
        };
        _this.renderSubTabs = function (subTab, depth) {
            var content = subTab.props.children.map(function (child, index) {
                if (child.type === SubTab_1.SubTab) {
                    return _this.renderSubTabs(child, depth + 1);
                }
                else {
                    return _this.labels(child, depth + 1);
                }
            });
            return (React.createElement("ul", { className: 'sub_tab vertical_tabs_labels' },
                React.createElement("li", { style: { paddingLeft: (12 * depth) } },
                    React.createElement("span", null, subTab.props.label)),
                content));
        };
        _this.renderTitles = function () {
            if (_this.props.children) {
                var tabLabel = classNames({
                    tabs_labels: !_this.props.vertical,
                    vertical_tabs_labels: _this.props.vertical
                });
                var content = _this.props.children.type === Tab_1.TabPanel ?
                    _this.labels(_this.props.children, 0) :
                    _this.props.children.map(function (child, index) {
                        if (child.type === SubTab_1.SubTab) {
                            return _this.renderSubTabs(child, 0);
                        }
                        else {
                            return _this.labels(child, 0);
                        }
                    });
                return (React.createElement("ul", { className: tabLabel }, content));
            }
            else {
                return '';
            }
        };
        _this.renderContent = function () {
            var tabContent = classNames({
                tabs_content: !_this.props.vertical,
                vertical_tabs_content: _this.props.vertical
            });
            var pIndex = _this.state.panels.find(function (panel) { return panel.key === _this.state.selected; });
            return (React.createElement("div", { className: tabContent }, pIndex ? pIndex.panel : ''));
        };
        _this.state = {
            selected: _this.props.selected ? _this.props.selected : 0,
            panels: _this.createPanelsArray(_this.props.children)
        };
        return _this;
    }
    Tab.prototype.componentWillReceiveProps = function (nextProps) {
        this.setState({ panels: this.createPanelsArray(nextProps.children) });
    };
    Tab.prototype.render = function () {
        var tabs = classNames({
            tabs: !this.props.vertical,
            vertical_tabs: this.props.vertical
        });
        var titles = this.renderTitles();
        var content = this.renderContent();
        if (this.props.vertical) {
            return (React.createElement("div", { className: tabs },
                React.createElement("div", { className: 'row' },
                    React.createElement("div", { className: 'col-lg-2' }, titles),
                    React.createElement("div", { className: 'col-lg-10' }, content))));
        }
        else {
            return (React.createElement("div", { className: tabs },
                titles,
                content));
        }
    };
    return Tab;
}(React.Component));
exports.Tab = Tab;
//# sourceMappingURL=Tab.js.map